exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".underwriting-status{text-align:center}.underwriting-status .status-title{font-size:24px;font-weight:500}.underwriting-status .status-text{font-size:16px;font-weight:300;margin-top:2rem;margin-bottom:2rem}.underwriting-status .status-subtext{font-size:14px;font-weight:300}.underwriting-status .spinner{margin-top:2rem;margin-bottom:2rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Quoters/Americo/steps/UnderwritingStatus.scss
// module id = 7666
// module chunks = 13